import React, { Component, useEffect, useState } from "react";
import { BrowserView, MobileView } from "react-device-detect";
import useAnalyticsEventTracker from "../../core/service/useAnalyticsEventTracker";
import ReactGA from "react-ga4";
import BurekolMobileDanamon from "./burekolMobileDanamon";
import { useLocation } from "react-router-dom";
import BurekolWebDanamon from "./burekolWebDanamon";


const BurekolComponent = () => {
  const [bankName, setBankName] = useState("");
  const location = useLocation();
  useEffect(() => {
    ReactGA.send({
      hitType: "pageview",
      page: window.location.pathname + window.location.search,
      title: "Account",
    });

    if (location.pathname.split("/")[2] != undefined) {
      setBankName(location.pathname.split("/")[2])
    }
  }, []);

  
  return (
    <>
      <BrowserView>
        {
          bankName == "danamon" && <BurekolWebDanamon></BurekolWebDanamon>
        }
      </BrowserView>
      <MobileView>
        {
          bankName == "danamon" && <BurekolMobileDanamon></BurekolMobileDanamon>
        }
      </MobileView>
    </>
  );
};

export default BurekolComponent;
